module.exports = __webpack_public_path__ + "static/media/aux.76d91611.png";